module.exports = __webpack_public_path__ + "static/img/icon-01.e349cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-to-books/icon-01.png
// module id = REDb
// module chunks = 1